export const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_CUSTOM_AUTH_CLIENT_ID,
        authority: `https://login.microsoftonline.com/${process.env.REACT_APP_CUSTOM_AUTH_TENANT}`,
        // Use the current origin so this works on any registered host (localhost, dev SWA, etc.)
        redirectUri: window.location.origin,
    },
    cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: false,
    },
};
export const loginRequest = {
    scopes: [`api://${process.env.REACT_APP_CUSTOM_AUTH_CLIENT_ID}/access_as_user`]
};
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com"
};
